<template>
	<Container :customer='showCustomer' @colseCustomer='showCustomer=false'>
		<TopBar />
		<div class='load' v-show='showLoading'>
			<loading />
		</div>
		<div class="cartPage" v-if='!showLoading'>
			<Alert class="toPc" type="info" v-if='false'>
				想省&nbsp;<span>${{difference}}</span>&nbsp;&nbsp;<Button class="goto" type="primary" @click="goto">快來成為優惠顧客吧</Button>
				<template slot="desc"></template>
			</Alert>
			<!-- 選中倉庫 -->
			<div class='warehouse'>
				運送方式 Type of Delivery: &nbsp;&nbsp;
				<span v-if="!isMerge && !isSelfPickup">單次送貨 (Single Delivery)</span>
				<span v-if="isMerge">合併發貨 (Group Delivery)</span>
				<span v-if="isSelfPickup">合併自提 (Group Pickup)</span>
				<span v-if="isSelfLargePickup">合併自提 (Group Pickup)</span>
				<!-- <Button class='selectWarehouse' type="primary" ghost>
					<template v-if='!default_store.Code'>
						請選擇配送方式
					</template>
					<template v-else>
						{{default_store.Name}}( {{default_store.Code=='501'?'Package Deliver':'Pick up Station'}})
					</template>
				</Button> -->
			</div>
			<!-- 地址標題 -->
			<div class='addressTitle' v-if='getVipNo'>
				<b>選擇收貨地址 Select Delivery Address&nbsp;&nbsp;訂單確認後更改送貨地址, 每張訂單將收取港幣$20手續費。</b>
				<Button class='addAddress' type="primary" @click='addAddress' ghost>新增收貨地址 (Add New Delivery Address)</Button>
			</div>
			<!-- 地址 -->
			<div id='Anchor_props' class='address transition_dom' v-if='getVipNo&&!isMobile'>
				<template v-for='(address,index) in sortaddresse'>
					<div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)' @mouseenter='hoverActive=address.id' @mouseleave="hoverActive=-1">
						<div class="left">
							<span class="name">{{address.name}}</span>
							<span class="tel">{{address.moblie_phone}}</span>
							<Tag v-if="address.is_default" class="addressTag" color="#B176C5">帳戶預設地址&nbsp;&nbsp;Default Address</Tag>
							<p>
								<!-- <i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i> -->
								{{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp; {{address.street}}&nbsp;&nbsp;{{address.street2}}&nbsp;&nbsp;{{address.email}}&nbsp;&nbsp;
							</p>
						</div>
						<div class="right" v-show='address.id==hoverActive'>
							<!-- <Icon type="ios-paper-outline" size='20' color='#B176C5' /> &nbsp;
                        <Icon type="ios-trash-outline" size='20' color='#B176C5' /> -->
							<img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
							&nbsp;
							<img title="刪除地址" src="@/assets/del.png" v-on:click.stop='cdeleteAddress(address)'>
						</div>
					</div>
				</template>
			</div>
			<div id='Anchor_props' class='address transition_dom' v-else-if="isMobile&&getVipNo">
				<template v-for='(address,index) in sortaddresse'>
					<div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)'>
						<div class="left">
							<span class="name">{{address.name}}</span>
							<span class="tel">{{address.moblie_phone}}</span>
							<Tag v-if="address.is_default" class="addressTag" color="#B176C5">帳戶預設地址&nbsp;&nbsp;Default Address</Tag>
							<p>
								<!-- <i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i> -->
								{{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.county}}&nbsp;&nbsp;{{address.town}}&nbsp;&nbsp;{{address.street}}&nbsp;&nbsp;{{address.street2}}&nbsp;&nbsp;
							</p>
						</div>
						<div class="right">
							<!-- <Icon type="ios-paper-outline" size='20' color='#B176C5' /> &nbsp;
                        <Icon type="ios-trash-outline" size='20' color='#B176C5' /> -->
							<img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
							&nbsp;
							<img title="刪除地址" src="@/assets/del.png" v-on:click.stop='cdeleteAddress(address)'>
						</div>
					</div>
				</template>
			</div>

			<span v-if='addresses.length > 4' class="showAllAddr" @click='operating'>{{isAllAddress?'收起地址':'顯示全部地址'}}&nbsp;<b>&gt;</b></span>
			<!-- 産品列錶 -->
			<div class="productList">
				<table cellspacing="0">
					<tr class="product">
						<th class="checkbox"><Checkbox size='small' @on-change="allCarSel" v-model="allSel"></Checkbox>全選</th>
						<th class="p-name" colspan='1'>産品信息&nbsp;&nbsp;Product Description</th>
						<th style="width:25%;">單價&nbsp;&nbsp;Unit Price (HKD)</th>
						<th style="width:20%;">數量&nbsp;&nbsp;Qty</th>
						<th class='no_mobile'>小計&nbsp;&nbsp;Subtotal</th>
						<!-- <th class='no_mobile'>點數兌換</th> -->
					</tr>
					<tr class="product" v-for="(products,productindex) in menuList" :key="products.sku">
						<td class="p-checkbox">
							<Checkbox size='small' @on-change="carSel(products.sku)" v-model="cartCheck[products.sku]"></Checkbox>
						</td>
						<td class="p-name">
							<div class="p-left">
								<div  class="p-img" style="cursor: pointer;" @click="goDetail(products)">
									<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.image_path_big">
								</div>
							</div>
							<div class="p-right">
								<div class="p-name1">
								<div style="cursor: pointer;" class="p-name-span" @click="goDetail(products)">
									<span class='span_name'> {{products.name}}</span>
									<div class='hotlist'>
										<span v-if='products.is_hot == 1' class="hot">熱銷<b class='no_mobile'>(Hot)</b></span>
										<template v-if='products.is_hot == 1'>&nbsp;</template>
										<span v-if='products.is_new == 1' class="hot">新品<b class='no_mobile'>(New)</b></span>
										<template v-if='products.is_new == 1'>&nbsp;</template>
										<span v-if='products.is_promotion == 1' class="hot">促銷<b class='no_mobile'>(Promotion)</b></span>
									</div>
								</div>

								<!-- <template v-if="isExchange(products)&&!isMobile">
									<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="showChoosePTList"></select-point>
								</template> -->

							</div>
							<div class="other">
								<span v-if="isOriginalPrice==false">PV點數: {{products.specproducts[0].pv}}</span>
								<span>{{products.specproducts[0].specs[0].name}}: {{products.specproducts[0].specs[0].value}}</span>
								<!-- <span v-if="products.specproducts[0].pt>0 && isOriginalPrice==false">PT: {{products.specproducts[0].pt}}</span> -->
							</div>
							<template v-if='!isExchange(products)&&!isMobile'>
								<!-- <section class='select_pt_no'><span>點數兌換<div class="no_mobile">Point Redeem</div></span></section> -->
							</template>
							</div>
						
						</td>
						<td class="price">{{isPVOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price}}</td>
						<td class="count">
							<template v-if='noStockText(products)'>
								<!-- <span class='show_nostock'>僅快遞<em class="no_mobile">(Only Delivery)</em></span> -->
								<span class='show_nostock' v-html="noStockText(products)"></span>
								<span class='delete' @click='deleteProduct(products)'>刪除(Del)</span>
							</template>
							<div :class="{'offset':isExchange(products)&&isMobile } " v-else>
								<template v-if='isMobile'>
									<buyCart v-model="products.num" :iscart='2' :product="products" class='products_add' style='display:inline-block' @showPromoCode='showPromoCode'></buyCart>
								</template>
								<template v-else>
									<buyCart v-model="products.num" :product="products" style='display:inline-block' @showPromoCode='showPromoCode'></buyCart>
								</template>
								<div class="point_mobile" v-if='isMobile'>
									<template v-if="isExchange(products)">
										<!-- <select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="showChoosePTList"></select-point> -->
									</template>
									<template v-else>
										<!-- <section class='select_pt_no'><span>點數兌換</span></section> -->
									</template>
								</div>

								<!-- <buyCart v-model="products.num" :product="products" style='display:inline-block'></buyCart> -->
							</div>

						</td>
						<!-- <td class='sub-dh no_mobile'>{{isNaN(products.point / products.pt)?0:products.point / products.pt}}</td> -->
						<td class="sub-total no_mobile">HK${{(isPVOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price)*(products.num-(isNaN(products.point / products.pt)?0:products.point / products.pt))}}</td>
						<!-- <td class="sub-point no_mobile">
							<template v-if="isExchange(products)&&!isMobile">
								<select-point :products='products' :poinBalance='poinBalance' @showChoosePTList="showChoosePTList"></select-point>
							</template>
						</td> -->
					</tr>
					<tr class="product promote" v-for="(products,productindex) in promoteList" v-if="products.control!=-1">
						<template v-if='products.control>0'>
							<td></td>
							<td class="p-name">
								<div class="p-left">
								<div  class="p-img">
									<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.image_path_big">
								</div>
								</div>
								<div class="p-right">
									<div>
									<span class='p-name-span'>
										<span>{{products.name}}</span>
										<!-- <span class="promote-tag">{{products.promote_name}}</span> -->
										<p class="returninfo">
											<img src="@/assets/order/promotion.png">
											<span style="" class="">{{products.promote_name}}</span>
										</p>
									</span>
								</div>
								<div class="other">
									<span>規格：{{products.specification}}</span>
								</div>
								</div>
								

							</td>
							<td class="price">{{products.price}}</td>
							<td class="count" style="color: #f60;font-size: 16.41px;font-weight: bold;">
								<template v-if='noStock1(products)'>
									<span class='show_nostock'>暫售完<em class='no_mobile'>(Out of Stock)</em></span>
								</template>
								<template v-else>
									{{products.num}}
								</template>

							</td>
							<td class='no_mobile'></td>
							<td class="sub-total no_mobile"></td>
						</template>
						<template v-else>
							<div class='product_no'>
								{{products.promote_name}}
							</div>
						</template>

					</tr>
				</table>
			</div>
			<!-- 價格顯示區域 -->
			<div class="gather">
				<div class='gather-left'>
					<div class="element total-price">
						<span class="name">産品總價(Product Total Price):</span>
						<span class="value">HK${{cartPrice.total_product_amount.toFixed(2)}}</span>
					</div>
					<div class="element total-pt">
						<span class="name">産品總點數(Product Total PV):</span>
						<span class="value">{{cartPrice.total_pv.toFixed(2)}}</span>
					</div>
					<!-- <div class="element total-pv ar" v-if='getVipNo'>
						<span @click="oepnDoubt('Tips_Redeem_Point')" class="name">兌換點數(Redeem Point):
							<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(餘:{{ptRealBalance.toFixed(2)}})</b>
						</span>
						<span class="value">{{cartPrice.total_change_point.toFixed(2)}} </span>
					</div> -->
					<div class="element total-fee" v-if='getVipNo'>
						<!-- <span class="name">配送費(Delivery Fee): -->
						<span @click="oepnDoubt('Tips_Free_Freight')" class="name">配送費/手續費(Delivery Fee/Handling Charge):
							<!-- <span style='font-size:13px' v-if='lrp_text'>{{lrp_text}}</span> -->
							<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
						</span>
						<div class="value">
							<div class="mdeliveryFemv" v-if='free>0&&!isMerge&&!isSelfPickup&&!isSelfLargePickup'>
								<div style="color: rgb(255, 70, 29);border-color: rgb(255, 70, 29);">
									<p style="color: rgb(255, 70, 29);">免{{fee - free < 0 ? fee.toFixed(2) : free.toFixed(2)}}</p>
								</div>
							</div>
							<span class="ellipsis" :class="{add_x: free > 0&&!isMerge&&!isSelfPickup&&!isSelfLargePickup, move_x:(deliveryFee)>0}" style="width:initial" v-text='resuldeliveryFee()'></span>
						</div>

					</div>

					<!-- <div class="element ar" v-if='getVipNo'>
						<span @click="oepnDoubt('Tips_Product_Credits')" class="name">産品積分支付(Product Credits):<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(餘:{{arRealBalance.toFixed(2)}})</b></span>
						<span class="value"><input style='height:24px;width:80px;' v-model="arValue" @blur="setOtherCar" placeholder='産品積分'></span>
					</div> -->
					<!-- <div class="element ar" v-if='getVipNo'>
						<span @click="oepnDoubt('Tips_Redeem_Point')" class="name">點數餘額(Point Balance):<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(餘:{{poinBalance.toFixed(2)}})</b></span>
						<span class="value">{{cartPrice.total_change_point.toFixed(2)}}</span>
					</div> -->
					<!-- <div class="element balance" v-if='getVipNo&&abshow'>
						<span @click="oepnDoubt('Tips_Product_AB')" class="name">賬戶餘額支付(Account Balance):<img class='tip-doubt' src="http://doc.doterra.cn/uploads/global/doubt.png">
							<b>(餘:{{realBalance.toFixed(2)}})</b></span>
						<span class="value"><input style='height:24px;width:80px;' v-model="abValue" @blur="setOtherCar" placeholder='賬戶餘額'></span>
					</div> -->

					<div class="element total-amount">
						<span class="name">應支付金額(Order Total):</span>
						<span class="value">HK${{payFee}}</span>
					</div>
					<!-- <div class="element lapsePv" v-if='getVipNo'>
						<span class="name">三個月內即將過期點數:</span>
						<span class="value">{{expiryPoint}}
							&nbsp;&nbsp;
							<a class='lapseMore' @click="expiryMore">更多</a>
						</span>
					</div> -->
					<div>
						<div style="border: 1px solid #B176C5;border-radius: 20px;padding: 20px;margin: 20px 0;">
							<div style="color: #B176C5;font-size: 20px;text-align: center;margin-bottom: 10px;">合併選項</div>
							<div :style="{display: isMobile ? 'block' : 'flex',alignItems: isMobile ? 'flex-start' : 'center',justifyContent: isMobile ? 'flex-start' : 'space-between',}">
								<div class="element merge" v-if='mergeShow'>
									<span class="name">
										<Checkbox size='small' @on-change='checkChanged($event,"isMerge")' v-model="isMerge">{{mergeData.title}}</Checkbox><img style="cursor: pointer;" class='tip-doubt' @click="oepnDoubt('Tips_Product_Merge')" src="http://doc.doterra.cn/uploads/global/doubt.png"><br><span style="font-size: 16px;">{{ mergeData.subTitle }}</span>
										<!-- <b style="cursor: pointer;" @click="oepnDoubt('Tips_Product_Merge')">{{mergeData.subTitle}}</b> -->
									</span>
								</div>
								<div class="element merge" v-if='selfPickupShow'>
									<span class="name">
										<Checkbox size='small' @on-change='checkChanged($event,"isSelfPickup")' v-model="isSelfPickup">{{selfPickupData.title}}</Checkbox><img style="cursor: pointer;" class='tip-doubt' @click="oepnDoubt('Tips_Product_SelfPickup')" src="http://doc.doterra.cn/uploads/global/doubt.png"><br><span style="font-size: 16px;">{{ selfPickupData.subTitle }}</span>
									</span>
								</div>
							</div>
							<div class="element merge" v-if='selfLargePickupShow'>
								<span class="name">
									<Checkbox size='small' @on-change='checkChanged($event,"isSelfLargePickup")' v-model="isSelfLargePickup">{{selfLargePickupData.title}}</Checkbox><img style="cursor: pointer;" class='tip-doubt' @click="oepnDoubt('Tips_Product_SelfLargePickup')" src="http://doc.doterra.cn/uploads/global/doubt.png"><br><span style="font-size: 16px;">{{ selfLargePickupData.subTitle }}</span>
								</span>
								<div style="margin: 10px 0;">
									<Select v-model='selfLargePickupPerson' size='large' placeholder='請選擇團隊合併自提代表' filterable clearable :disabled="!isSelfLargePickup">
										<Option v-for='option in selfLargePickupPersonData' :value='option.Proxy' :key='option.id' :label='option.name'> </Option>
									</Select>
								</div>
							</div>
						</div>
						<div class="element merge" v-if='isMerge || !(isSelfPickup || isSelfLargePickup)'>
							<span class="name">
								<b style="cursor: pointer;" @click="oepnDoubt('Tips_Product_Merge')" v-html="mergeData.extStr2"></b>
							</span>
						</div>
						<div class="element merge" v-if='isSelfPickup'>
							<span class="name">
								<b style="cursor: pointer;" @click="oepnDoubt('Tips_Product_SelfPickup')" v-html="selfPickupData.extStr2"></b>
							</span>
						</div>
						<div class="element merge" v-if='isSelfLargePickup'>
							<span class="name">
								<b style="cursor: pointer;" @click="oepnDoubt('Tips_Product_SelfLargePickup')" v-html="selfLargePickupData.extStr2"></b>
							</span>
						</div>
					</div>
				</div>
				<div class='gather-right'>
					<div>
						<Button :disabled='settlementLoad||continueLoad' class='cleanBtn' type='primary' @click='cleanCart'>清除購物車<b>Clear Cart</b></Button>
						<i class='btnW'></i>
						<Button :loading="continueLoad" :disabled='settlementLoad' class='gobuy' type='primary' @click='confirmLoad(1)'>繼續購物<b>Continue Shopping</b></Button>
					</div>
					<Button :loading="settlementLoad" :disabled='continueLoad' class='confirm' type='primary' @click='confirmLoad1' size='large' long>進行結賬 <b>Proceed to Checkout</b></Button>
				</div>
			</div>
		</div>
		<Warehouse :show='warehouseOpen' :storeId='default_store_id' @confirm='selectStore' @cancel='warehouseOpen=false' />
		<editAddressView :title="editAddress.id>0?'編輯地址(Edit address)':'新增地址(New address)'" :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='loading'></editAddressView>

		<Modal title="生日專屬禮遇" v-model="BHshow" :closable="false" :mask-closable="false">
			<div class='main-bh'>
				<p class='tip' :class='{highlight:BHerror_text}'><b>溫馨提示&nbsp;:&nbsp;</b>僅限最多6位英文字母，大小寫皆可，不可空格。例PeterZ, ZhuYQ</p>
				<Input v-model="BHtext" :class='{error:BHerror_input}' placeholder="請填寫您需要定製的生日禮遇專屬文字"></Input>
			</div>
			<div slot="footer">
				<button @click="BHscancel" type="button" class="ivu-btn ivu-btn-text ivu-btn-large"> <span>取消(cancel)</span></button>
				<button @click="confirmLoad(2)" type="button" class="ivu-btn ivu-btn-primary ivu-btn-large"><span>確認(confirm)</span></button>
			</div>
		</Modal>
		<newCustomer :value='newValue' :isCart='true' @close='close' @login='goLogin' />
		<PromoCode :products='PromoModel' :show='PromoModelShow' :opType='PromoModelType' @showPromoCode='showPromoCode'></PromoCode>
	</Container>

</template>

<script>
import { api_methods } from "@/service/loadData";
import TopBar from "@/components/common/TopBar";
import selectPoint from "@/components/order/selectPoint";
import buyCart from "@/components/order/buyCart";
import loading from "@/components/order/loading";
import Warehouse from "@/components/order/warehouse";
import editAddressView from "@/components/order/editAddressView";
import newCustomer from "@/components/order/NewCustomer";
import PromoCode from "@/components/order/PromoCode";
import util from "@/config/util";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import {
	systemConfigMethods,
	cartInfoMethods,
	userInfoOrderMethods,
	promoCodeMethods,
	addressMethods,
	promoteMethods,
	productLimtMethods,
	getImgPath,
} from "@/components/common/mixin";
import { cvoUrl } from "@/config/env";
export default {
	data() {
		return {
			isAllAddress: false,
			choosedProducts: null, //當前選中兌換商品
			showPTChange: false,
			continueLoad: false,
			settlementLoad: false,
			showLoading: true,
			warehouseOpen: false,

			LRPNum: null,

			addresses: [],
			doubtKey: {},

			productList: {}, //所有産品集合

			arBalance: 0.0,
			poinBalance: 0.0,
			expiryPoint: 0.0,
			balance: 0.0,
			arValue: 0,
			abValue: 0,
			hoverActive: -1,

			BHshow: false,
			BHtext: null,
			BHerror_text: null,
			BHerror_input: null,

			initaddresH: null,
			mobileMode: false,
			newValue: false,
			userBalance: [],
			abshow: false,
			isMerge: false,
			isSelfPickup: false,
			isSelfLargePickup: false,
			isSelfLargePickupShow: false,
			mergeData: {},
			selfPickupData: {},
			selfLargePickupData: {},
			selfLargePickupPersonData: [],
			selfLargePickupPerson:'',
			showCustomer:false,
			allSel:true,
			noBirthday:'2020-11-01',

			//當前選中大會code
			PromoModel: null,
			PromoModelShow: false,
			PromoModelType:null,
			free:0, //運費減免
			fee: 0,
		};
	},
	created() {
		this.$nextTick(function () {
			if (document.documentElement.clientWidth < 1090) {
				this.mobileMode = true;
			}
			this.initData();
		});
	},
	mounted() {},
	watch: {
		addresses: function (value, ovalue) {
			if (ovalue && ovalue.length > 0) {
				var change = value.filter(
					(u) => u.id == this.qchoosedAddress.id
				);
				if (change[0]) {
					this.CHOOSE_ADDRESS({
						address: change[0],
						index: 0,
					});
				}
			}
		},
		"cartInfo.value"(cur, old) {
			if (cur && !cur.detail[0]) {
				if (this.orderType != 0) {
					this.$router.push("/order/product");
				} else {
					this.$router.push("/order/product");
				}
			}
			if (!cur) {
				this.$router.push("/order/product");
			}
		},
		payPv: function (value, ovalue) {
			// if (!this.showLoading) {
			// 	if (this.isOriginalPrice && this.selfCarNo) {
			// 		if (!this.isPVOriginalPrice && ovalue < 100) {
			// 			this.setOtherCar();
			// 			//this.showTips("恭喜您滿足100點數,享受優惠價格", 3000);
			// 		} else if (ovalue >= 100 && this.isPVOriginalPrice) {
			// 			this.setOtherCar();
			// 			// this.showTips(
			// 			// 	"非常抱歉點數不足100,無法享受優惠價格",
			// 			// 	3000
			// 			// );
			// 		} else if (ovalue < 100) {
			// 			// this.showTips(
			// 			// 	"如再購買" +
			// 			// 		(100 - value).toFixed(2) +
			// 			// 		"點,可以升級成為優惠顧客",
			// 			// 	4000
			// 			// );
			// 		}
			// 	} else if (this.newcustomer) {
			// 		if (value > 0 && value < 50) {
			// 			this.showTips(
			// 				"如再購買" +
			// 					(50 - value).toFixed(2) +
			// 					"點,單筆訂單滿50點,即可獲得LRP回饋點數",
			// 				4000
			// 			);
			// 		}
			// 	}
			// }
		},
	},
	mixins: [
		systemConfigMethods,
		userInfoOrderMethods,
		cartInfoMethods,
		addressMethods,
		promoCodeMethods,
		productLimtMethods,
		promoteMethods,
		getImgPath,
	],
	components: {
		TopBar,
		selectPoint,
		buyCart,
		Warehouse,
		editAddressView,
		loading,
		newCustomer,
		PromoCode
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo"]),
		...mapState({
			sysConfig: (state) => state.common.sysConfig,
			warehouseInfo: (state) => state.order.warehouseInfo,
			productInfo: (state) => state.order.productInfo,
			productStockInfo: (state) => state.order.productStockInfo,
			choosedAddress: (state) => state.order.choosedAddress,
			newpromoCode: (state) => state.order.newpromoCode,
			userInfo: (state) => state.common.wechatUserInfo,
			guestInfo: (state) => state.common.guestInfo,
			forCustomer: (state) => state.order.forCustomer,
			cartInfo: (state) => state.order.cartInfo,
			promote: (state) => state.order.promote,
			productLimt: (state) => state.order.productLimt,
			orderType: (state) => state.order.orderType,
			cartCheck: (state) => state.order.cartCheck,
			balanceRecord: (state) => state.order.balanceRecord,
		}),
		mergeShow: function () {
			if (
				this.default_store_id == "501" &&
				!this.isbirthday &&
				this.mergeData.result
			) {
				return true;
			}
			return false;
		},
		selfPickupShow: function () {
			if (
				this.default_store_id == "501" &&
				!this.isbirthday &&
				this.selfPickupData.result
			) {
				return true;
			}
			return false;
		},
		selfLargePickupShow: function () {
			if (
				this.default_store_id == "501" &&
				!this.isbirthday &&
				this.selfLargePickupData.result &&
				this.isSelfLargePickupShow
			) {
				return true;
			}
			return false;
		},
		nowDate: function () {
			let Config = this.systemDetail;
			if (Config?.now_time) {
				return util.formatDate.dateFromStr(Config.now_time);
			}
			return util.realNowTime();
		},
		isMobile() {
			if (document.body.clientWidth <= 768) {
				return true;
			}
			return false;
		},
		isAllSelCart(){
			var cartList = this.shopCart || [];
			var cartCheck = this.cartCheck || {};
			var result=true;
			cartList.forEach((item, index) => {
				if (!cartCheck[item.sku]) {
					result=false
				}
			});
			return result;
		},
		selShopCart() {
			var cartList = this.shopCart || [];
			var cartCheck = this.cartCheck || {};
			var arry = [];
			cartList.forEach((item, index) => {
				if (cartCheck[item.sku]) {
					arry.push(item);
				}
			});
			return arry;
		},
		selfPromoCode(){
			var cartCheck = this.cartCheck || {};
			var promoData=this.firstPromoCode;
			if(promoData){
				if(cartCheck[promoData.exchange_sku]){
					return promoData
				}
			}
			return null
		},
		selffirstOpentoAll(){
			 var item = this.selfPromoCode;
			if (item && item.is_opentoall == 0) {
				return item
			}
			return null;
		},
		rtPrice() {
			let total_price = 0;
			if (this.selShopCart[0]) {
				this.selShopCart.forEach((item, index) => {
					total_price += item.rt_price * item.num;
				});
			}
			return total_price;
		},
		pcPirce() {
			let total_price = 0;
			if (this.selShopCart[0]) {
				this.selShopCart.forEach((item, index) => {
					total_price += item.pc_price * item.num;
				});
			}
			return total_price;
		},
		difference() {
			return (this.rtPrice - this.pcPirce).toFixed(2);
		},
		warehouseList: function () {
			return [...((this.warehouseInfo || {}).value || {})];
		},
		productStock: function () {
			let ret = [...((this.productStockInfo || {}).value || {})];
			return ret;
		},
		qchoosedAddress: function () {
			return this.choosedAddress || {};
		},
		sortaddresse: function () {
			return this.addresses.sort(function (a, b) {
				return b.is_default - a.is_default;
			});
		},
		ptRealBalance:function(){
			if(this.poinBalance<=0) return  this.poinBalance;

			let abInput = this.poinBalance-this.cartPrice.total_change_point;
			return abInput>0?abInput:0;
		},
		arRealBalance: function () {
			if (this.arBalance <= 0) return this.arBalance;

			let abInput = this.arBalance - this.arFee;
			return abInput > 0 ? abInput : 0;
		},
		realBalance: function () {
			if (this.balance <= 0) return this.balance;

			let abInput = this.balance - this.abFee;
			return abInput > 0 ? abInput : 0;
		},
		abFee: function () {
			let df = this.abValue + "";
			df = df.replace(/[^\d.]/g, "");
			df = df.replace(/\.{2,}/g, ".");
			df = df.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			df = df.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
			if (df.indexOf(".") < 0 && df != "") {
				df = parseFloat(df);
			}
			var ar = this.balance < 0 ? 0 : this.balance;
			if (df > ar) {
				df = ar;
			}
			var resultcashPay = Number(this.abcashPay.toFixed(2));
			if (df > resultcashPay) {
				df = resultcashPay;
			}
			this.abValue = df;
			return df;
		},
		arFee: function () {
			let df = this.arValue + "";
			df = df.replace(/[^\d.]/g, "");
			df = df.replace(/\.{2,}/g, ".");
			df = df.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			df = df.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
			if (df.indexOf(".") < 0 && df != "") {
				df = parseFloat(df);
			}
			var ar = this.arBalance < 0 ? 0 : this.arBalance;
			if (df > ar) {
				df = ar;
			}
			var resultcashPay = ((this.arcashPay / 3) * 2).toFixed(2);
			if (Number(df) > resultcashPay) {
				df = resultcashPay;
			}
			this.arValue = df;
			return df;
		},
		deliveryFee: function () {
			let df = 0;
			var item = this.selfPromoCode;
			if (item) {				
				df = item.freight;
			} else if (this.isMerge || this.isSelfPickup || this.isSelfLargePickup) {
				this.fee = this.systemDetail.float_delivery_fee;
				df = this.fee;
			} else if(this.choosedAddress && this.choosedAddress.province_id == '110000'){
				this.fee = this.systemDetail.float_delivery_fee_hongkong;
				df = this.fee;
			} else if(this.choosedAddress && this.choosedAddress.province_id == '120000'){
				this.fee = this.systemDetail.float_delivery_fee_macao;
				df = this.fee;
			} else {
				df = this.baseDeliveryFee;
			}
			df = df - this.free;
			df = df > 0 ? df : df == this.systemDetail.float_delivery_fee - this.free ? this.fee : 0;
			return df;
		},
		//現金待支付金額
		cashPay: function () {
			let df =
				Number(this.cartPrice.total_product_amount) +
				Number(this.deliveryFee) +
				Number(this.baseServiceFee);
			return df;
		},
		arcashPay: function () {
			let df =
				Number(this.cartPrice.total_product_amount) +
				Number(this.deliveryFee) +
				Number(this.baseServiceFee);
			return df;
		},
		//現金待支付金額
		abcashPay: function () {
			let df =
				Number(this.cartPrice.total_product_amount) +
				Number(this.deliveryFee) +
				Number(this.baseServiceFee);
			var balance = Number(this.arFee < 0 ? 0 : this.arFee);
			df = df - balance < 0 ? 0 : df - balance;
			return df;
		},
		//待支付費用
		payFee: function () {
			var arFee = Number(this.arFee);
			var abFee = Number(this.abFee);
			let df = this.cashPay - abFee - arFee;
			if (df < 0) {
				//this.arValue = this.cashPay;
				df = this.cashPay - abFee - arFee;
			}
			return Math.abs(Number(df)).toFixed(2);
		},
		lrp_text: function () {
			if (!this.newcustomer || this.LRPNum == null) return null;

			if (this.LRPNum < 6) {
				return ` 還差${6 - Number(this.LRPNum)}個月滿足免運費資格`;
			} else {
				return "查詢免運費資格Know more to waive delivery fee";
			}
		},
		menuList() {
			let productListArr = new Array();
			let newArr = this.shopCart || [];
			let op = this.isPVOriginalPrice;
			newArr.forEach((item, index) => {
				let product = this.productList[item.sku];
				if (!product) return;

				//處理購物車數據 limit num
				let productPrice = product.specproducts[0] || {};
				var Price = op
					? productPrice.original_price
					: productPrice.price;
				product.price = Price;
				product.point = item.point;
				product.pt = item.pt;
				product.num = item.num;

				productListArr.push(product);
			});
			if (newArr[0]) {
				this.loadpromoteList();
			}
			return productListArr;
		},
		isbirthday() {
			var birthdaydata = this.selShopCart.filter(
				(u) => u.product_flag == 10
			);
			if (birthdaydata[0]) {
				return true;
			}
			return false;
		},
	},
	methods: {
		...mapActions([
			"initWarehouseAction",
			"getCustomerNumStatisticsAction",
			"initProductStock",
			"selectWarehouseAction",
			"postAddAddressAction",
			"getWechatUserInfoAction",
			"delAddressAction",
			"getTipDetailAction",
			"saveCartAction",
			"saveStoreIdAction",
			"CheckPoint",
			"CheckAR",
			"CheckCart",
			"initPromoteAction",
			"updateCartAction",
			"getAccountBalanceAction",
			"checkAccountBalanceAction",
			"getSelfLargePickupWhiteListAction",
		]),
		...mapMutations([
			"SET_ORDERTYPE",
			"SET_CART_TOTAL",
			"CLEAR_CART",
			"CHOOSE_ADDRESS",
			"SET_ORDERNN",
			"EDIT_CART1",
			"REDUCE_NEWPROMOCODE",
			"SET_SELECTMERGE",
			"SET_CARTCHECK",
			"LOAD_CARTCHECK",
			"SET_CARTCHECKALL",
		]),
		optVirtualflag: function () {
			var df =this.baseDeliveryFee;
			var item = this.selfPromoCode;
			if (item) {
				df = item.freight;
			}
			if ((df < this.baseDeliveryFee) || this.free > 0) {
				return 2;
			}
			return 1;
		},
		isExchange: function (products) {
			return (
				!this.noStockText(products) &&
				products.specproducts[0].pt > 0 &&
				this.isOriginalPrice == false &&
				this.PromoPT &&
				this.poinBalance > 0
			);
		},
		async getAccountBalance() {
			let res = await this.getAccountBalanceAction();
			if (res && res[0]) {
				this.userBalance = res;
			}
			return [];
		},
		getAbBalance() {
			if (this.userBalance && this.userBalance[0]) {
				var res = this.userBalance.filter((u) => u.type == "AB");
				if (res[0]) {
					this.abshow = res[0].pass;
					return res[0].val;
				}
			}
			return 0;
		},
		getArBalance() {
			// let arResult = await api_methods.GetUserAccountAR(
			// 	this.getAccessToken,
			// 	"",
			// 	this.getVipNo,
			// 	0
			// );
			// if (
			// 	arResult &&
			// 	arResult.response &&
			// 	arResult.response.code == "1"
			// ) {
			// 	return arResult.data.value.ar;
			// 	//return -255;
			// }
			if (this.userBalance && this.userBalance[0]) {
				var res = this.userBalance.filter((u) => u.type == "AR");
				if (res[0]) {
					return res[0].val;
				}
			}
			return 0;
		},
		getPointBalance() {
			// var point = 0;
			// var expiryPoint = 0;
			// let pointResult = await api_methods.getUserAccountPoint(
			// 	this.getAccessToken,
			// 	"",
			// 	this.getVipNo,
			// 	0
			// );
			// if (
			// 	pointResult &&
			// 	pointResult.response &&
			// 	pointResult.response.code == "1"
			// ) {
			// 	point = pointResult.data.value.point;
			// 	expiryPoint = pointResult.data.value.expiryPoint;
			// 	//return 44;
			// }

			if (this.userBalance && this.userBalance[0]) {
				var res = this.userBalance.filter((u) => u.type == "PT");
				if (res[0]) {
					return {
						point: res[0].val,
						expiryPoint: res[0].expiryPoint,
					};
				}
			}
			return { point: 0, expiryPoint: 0 };
		},
		async initLRPNum() {
			if (!this.bogo_switch_tip && this.newcustomer) {
				var res = await this.getCustomerNumStatisticsAction(
					this.getVipNo
				);
				if (res && res[0]) {
					this.LRPNum = res[0].Nums1 || 0;
				} else {
					this.LRPNum = 0;
				}
			}
		},
		async defaultStore() {
			var item = this.warehouseList.filter((u) => u.Code == "501")[0];
			await this.selectStore(item);
		},
		async selectStore(item) {
			if (item.Code != "501" && this.selfPromoCode) {
				this.$Modal.warning({
					title: "小dō溫馨提示(Tips)",
					content: "使用了優惠代碼,隻能選中送貨上門哦!",
					onOk: () => {},
				});
			} else if (item.Code != this.default_store_id) {
				this.warehouseOpen = false;
				this.showLoading = true;
				// this.default_store_id = item.Code;
				// this.default_store=item;
				await this.initProductStock(item.Code);

				var ddm = "0";
				var ddmd = "門店自提";
				if (item.Code == "501") {
					//送貨上門
					ddm = "1";
					ddmd = "送貨上門";
				}
				this.selectWarehouseAction({
					default_delivery_mode: ddm,
					default_delivery_mode_desc: ddmd,
					default_store_id: item.Code,
					default_store_name: item.Name,
					default_store_nameen: item.NameEn,
				});
				this.handleProductStock();
				this.showLoading = false;
			} else {
				this.warehouseOpen = false;
			}
		},
		timeComparison(str, str1) {
			var valid_from = !str ? null : util.formatDate.dateFromStr(str);
			var valid_to = !str1 ? null : util.formatDate.dateFromStr(str1);
			var now = this.nowDate;
			return (
				(valid_from <= now || !valid_from) &&
				(valid_to >= now || !valid_to)
			);
		},
		async getMergeData() {
			var res = await this.getTipDetailAction("Tips_Product_Merge");
			if (res) {
				var ValidFrom = (res.ValidFrom || "").replace("T", " ");
				var ValidTo = (res.ValidTo || "").replace("T", " ");
				if (this.timeComparison(ValidFrom, ValidTo)) {
					this.doubtKey["Tips_Product_Merge"] = res.ontent;
					this.mergeData = {
						title:res.Title,
						subTitle:res.SubTitle,
						content:res.Content,
						extStr1: res.ExtStr1,
						extStr2: res.ExtStr2,
						result: true,
					};
				}
			}
		},
		async getselfPickupData() {
			var res = await this.getTipDetailAction("Tips_Product_SelfPickup");
			if (res) {
				var ValidFrom = (res.ValidFrom || "").replace("T", " ");
				var ValidTo = (res.ValidTo || "").replace("T", " ");
				if (this.timeComparison(ValidFrom, ValidTo)) {
					this.doubtKey["Tips_Product_SelfPickup"] = res.ontent;
					this.selfPickupData = {
						title:res.Title,
						subTitle:res.SubTitle,
						content:res.Content,
						extStr1: res.ExtStr1,
						extStr2: res.ExtStr2,
						result: true,
					};
				}
			}
		},
		async getselfLargePickupData() {
			var res = await this.getTipDetailAction("Tips_Product_SelfLargePickup");
			if (res) {
				var ValidFrom = (res.ValidFrom || "").replace("T", " ");
				var ValidTo = (res.ValidTo || "").replace("T", " ");
				if (this.timeComparison(ValidFrom, ValidTo)) {
					this.doubtKey["Tips_Product_SelfLargePickup"] = res.ontent;
					this.selfLargePickupData = {
						title:res.Title,
						subTitle:res.SubTitle,
						content:res.Content,
						extStr1: res.ExtStr1,
						extStr2: res.ExtStr2,
						result: true,
					};
				}
			}
		},
		checkChanged(e,key){
			if(key == 'isMerge' && e){
				this.isMerge = true;
				this.isSelfPickup = false;
				this.isSelfLargePickup = false;
			}else if(key == 'isSelfPickup' && e){
				this.isMerge = false;
				this.isSelfPickup = true;
				this.isSelfLargePickup = false;
			}else if(key == 'isSelfLargePickup' && e){
				this.isMerge = false;
				this.isSelfPickup = false;
				this.isSelfLargePickup = true;
			}else{
				this.isMerge = false;
				this.isSelfPickup = false;
				this.isSelfLargePickup = false;
			}
		},
		initAddress() {
			var initAddress = this.userInfo.value.binding.address || [];

			if (!this.choosedAddress) {
				var zc = initAddress.filter((u) => u.is_default == "1");
				if (zc[0]) {
					this.CHOOSE_ADDRESS({
						address: zc[0],
						index: 0,
					});
				} else {
					this.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			} else {
				//避免緩存數據
				var zc = initAddress.filter(
					(u) => u.id == this.choosedAddress.id
				);
				if (zc[0]) {
					this.CHOOSE_ADDRESS({
						address: zc[0],
						index: 0,
					});
				} else {
					this.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			}
		},
		setCartTotal(delivery_fee, service_fee, ar_value, ab_value, pvResult) {
			var result = this.isPVOriginalPrice;
			if (pvResult) {
				result = true;
			}
			this.SET_CART_TOTAL({
				delivery_fee,
				service_fee,
				ar_value,
				ab_value,
				result,
				check: true,
			});
		},
		setOtherCar() {
			var result = parseFloat(this.arFee);
			if (isNaN(result) || result <= 0) {
				result = 0;
			}
			var result1 = parseFloat(this.abFee);
			if (isNaN(result1) || result1 <= 0) {
				result1 = 0;
			}
			this.setCartTotal(
				this.deliveryFee,
				this.baseServiceFee,
				result,
				result1
			);
		},
		handleProductStock: function () {
			let newArr = this.shopCart;
			newArr.forEach((item) => {
				let product = this.productList[item.sku];
				if (product) {
					let sku = product.sku;
					let is_inventory = product.is_inventory;
					if (
						is_inventory == 1 ||
						(is_inventory == 10 && this.default_store_id == "501")
					) {
						product.control = -1; //未查詢到庫存信息
						product.stock = 0;
						let stockArry = this.productStock.filter(
							(u) => u.warehouse == this.default_store_id
						);
						if (stockArry[0]) {
							stockArry[0].stock.forEach((stock, index2) => {
								let control = stock.control;
								if (stock.sku === sku) {
									if (stock.stock <= 0) {
										product.control = control;
									} else {
										product.control = 2; //有庫存，可以銷售
									}
									product.stock = stock.stock;
								}
							});
						}
					} else if (is_inventory == 10) {
						product.control = -1;
					} else {
						product.control = 10; //不判斷庫存，任意銷售
						product.stock = 999999999;
					}
				}
			});
		},
		async cleanCart() {
			this.$Modal.confirm({
				title: "提示(Tip):",
				content:
					"確定要清除購物車嗎?<br>You sure you want to clear the cart?",
				loading: true,
				okText: "確定(Confirm)",
				cancelText: "取消(Cancel)",
				onOk: async () => {
					if (this.getVipNo) {
						let res = await api_methods.clearCart(
							this.getAccessToken,
							"",
							this.userInfo.value.binding.user_id
						);
						if (res && res.response && res.response.code == "1") {
							this.CLEAR_CART();
							this.$router.push({
								path: "/order/product",
							});
							this.$Modal.remove();
						} else {
							this.$Modal.error({
								title: "錯誤 (error)",
								content: res,
							});
						}
					} else {
						this.CLEAR_CART();
						this.$Modal.remove();
					}
				},
			});
		},
		async initData() {
			if (!this.shopCart[0]) {
				if (this.orderType != 0) {
					this.$router.push("/order/product");
				} else {
					this.$router.push("/order/product");
				}
				return false;
			}

			if (this.newcustomer) {
				this.SET_ORDERTYPE(11);
			} else {
				this.SET_ORDERTYPE(0);
			}
			await this.initWarehouseAction();

			this.productList = this.Produckey();

			await this.initProductStock(this.default_store_id);
			if (this.getVipNo) {
				if ((await this.initPromoteAction()) != 1) {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: "促銷獲取異常",
						okText: "確定",
						onOk: () => {
							this.$router.push("/order/product");
						},
					});
					return;
				}

				this.initLRPNum();

				this.addresses =
					this.userInfo.value &&
					(this.userInfo.value.binding.address || []);

				if (!this.isOriginalPrice) {
					await this.getAccountBalance();
					this.balance = this.getAbBalance();
					this.arBalance = this.getArBalance();
					var pointModel = this.getPointBalance();

					this.poinBalance = pointModel.point;
					this.expiryPoint = pointModel.expiryPoint;
				}
				this.initAddress();
			}

			this.LOAD_CARTCHECK();

			this.checkAutoAll();

			if (this.balance > 0) {
				this.abValue = this.balance;
			}
			var balanceRecord = this.balanceRecord || {};
			if (balanceRecord.ar_value > 0) {
				this.arValue = balanceRecord.ar_value;
			}

			this.setOtherCar();

			await this.getMergeData();
			await this.getselfPickupData();
			await this.getselfLargePickupData();
			let params = {
				vipNo: this.userInfo?.value?.binding?.register?.vip_no,	
				name: this.userInfo?.value?.binding?.name,	
			}
			let res = await this.getSelfLargePickupWhiteListAction(params);
			if(res && res.isinclude && res.data?.length){
				this.isSelfLargePickupShow = true;
				this.selfLargePickupPersonData = res.data;
			}else{
				this.isSelfLargePickupShow = false;
			}

			if (this.default_store_id != "501" && this.selfPromoCode) {
				this.$Modal.warning({
					title: "小dō溫馨提示(Tips)",
					content: "使用了優惠代碼,隻能選中送貨上門哦!",
					onOk: async () => {
						await this.defaultStore();
					},
				});
			} else {
				this.handleProductStock();
				this.showLoading = false;
			}
		},
		Produckey() {
			let listKey = {};
			this.productInfo.value.forEach((item) => {
				item.products.forEach((produc) => {
					if (!listKey[produc.sku]) {
						listKey[produc.sku] = produc;
					}
				});
			});
			return listKey;
		},
		async oepnDoubt(code) {
			var content = null;
			if (this.doubtKey[code]) {
				content = this.doubtKey[code];
			} else {
				var res = await this.getTipDetailAction(code);
				if (res) {
					content = res.Content;
					this.doubtKey[code] = content;
				}
			}

			this.$Modal.info({
				width: 750,
				title: "提示(Tip):",
				content: content,
				okText: '確定 Confirm',
			});
		},
		deliveryOnly(list) {
			var result = false;
			list.forEach((item, index) => {
				if (!result && item.product_flag != 1) {
					var obj = this.menuList.filter((u) => u.sku == item.sku);
					if (obj[0]) {
						if (obj[0].is_inventory == "10") {
							result = true;
						}
					}
				}
			});
			return result;
		},
		ListingOnly(list) {
			var result = false;
			list.forEach((item, index) => {
				if (!result && item.product_flag != 1) {
					var obj = this.menuList.filter((u) => u.sku == item.sku);
					if (obj[0]) {
						if (
							obj[0].online_myo_begin &&
							obj[0].online_myo_begin != "" &&
							this.nowDate <
								util.formatDate.dateFromStr(
									obj[0].online_myo_begin
								)
						) {
							result = true;
						}
					}
				}
			});
			return result;
		},
		checkLRPTPV(list) {
			var name = "";
			var pv = 0;
			list.forEach((item) => {
				if (item.product_flag != 20) {
					var ppt = item.pt > 0 ? item.point / item.pt : 0;
					pv += (item.num - ppt) * item.pv;
				} else {
					name += item.name + ",";
				}
			});
			if (pv >= 125) {
				return null;
			}
			return name.substring(0, name.length - 1);
		},
		Ispromote(ll) {
			//檢測此單是否存在促銷
			if (this.promote_code) {
				return 1;
			}
			var is = ll.filter((u) => u.product_flag == 1);
			if (is[0]) {
				return 1;
			}

			return 0;
		},
		allCartList() {
			let newArr = new Array();
			this.shopCart.forEach((item) => {
				if (item.num > 0) {
					var product_flag = item.is_lrpt_product || 0;
					if (item.is_hot == "1" && this.orderType != 0) {
						product_flag = 100;
					}

					var remark=null
					if(item.promo_code!=''&&item.promo_code){
						remark=this.getBySkuJson(item.sku)
					}

					newArr.push({
						attrs: [],
						extra: {},
						id: item.id,
						category_id: item.category_id,
						name: item.name,
						packing_fee: item.packing_fee,
						price: item.price,
						pt: item.pt,
						pv: item.pv,
						point: item.point,
						amount: item.amount, //現金支付金額
						ar_value: 0, //AR支付金額
						num: item.num, //數量(個數)，point支付和 amount支付總計個數
						sku_id: item.sku_id,
						sku: item.sku,
						specs: item.specs,
						stock: item.stock,
						selected: item.selected,
						spec_code: null,
						spec_name: null,
						product_flag: product_flag,
						promo_code: item.promo_code,
						Url: null,
						remark
					});
				}
			});
			return newArr;
		},
		shopCartList() {
			let newArr = new Array();

			this.selShopCart.forEach((item) => {
				if (item.num > 0) {
					var product_flag = item.is_lrpt_product || 0;
					if (item.is_hot == "1" && this.orderType != 0) {
						product_flag = 100;
					}
					newArr.push({
						attrs: [],
						extra: {},
						id: item.id,
						category_id: item.category_id,
						name: item.name,
						packing_fee: item.packing_fee,
						price: item.price,
						pt: item.pt,
						pv: item.pv,
						point: item.point,
						amount: item.amount, //現金支付金額
						ar_value: 0, //AR支付金額
						num: item.num, //數量(個數)，point支付和 amount支付總計個數
						sku_id: item.sku_id,
						sku: item.sku,
						specs: item.specs,
						stock: item.stock,
						selected: item.selected,
						spec_code: null,
						spec_name: null,
						product_flag: product_flag,
						promo_code: item.promo_code,
						Url: null,
					});
				}
			});
			return newArr;
		},

		setCarImg(list) {
			list.forEach((item, index) => {
				if (item.product_flag != 1) {
					var obj = this.menuList.filter((u) => u.sku == item.sku);
					if (obj[0]) {
						item.Url = obj[0].image_path_big;
						item.specification = obj[0].specification;
					}
				}
			});
			return list;
		},
		async saveThisCart(type, pvResult) {
			var birthdayCode = null;
			var birthdaydata = this.selShopCart.filter(
				(u) => u.product_flag == 10
			);
			if (birthdaydata[0]) {
				birthdayCode = "birthday";
			}

			var is_confirm = type;
			var result = parseFloat(this.arFee);
			if (isNaN(result) || result <= 0) {
				result = 0;
			}
			var result1 = parseFloat(this.abFee);
			if (isNaN(result1) || result1 <= 0) {
				result1 = 0;
			}

			this.setCartTotal(
				this.deliveryFee,
				this.baseServiceFee,
				result,
				result1,
				pvResult
			);
			let ll = this.allCartList();
			let cx = this.CxList();
			ll = [...ll, ...cx];
			let cv = this.cartInfo.value;

			if (type == 1) {
				type = this.Ispromote(ll);
			}
			ll = this.setCarImg(ll);
			var for_vipno = this.userInfo.value.binding.register.vip_no;
			var catalog = this.userInfo.value.binding.catalog;
			var first_order_status = this.userInfo.value.binding
				.first_order_status;
			if (this.forCustomer) {
				for_vipno = this.forCustomer.vipno;
				catalog = this.forCustomer.catalog;
				first_order_status = this.forCustomer.first_order_status;
			}
			if (this.selfPromoCode) {
				if (this.selfPromoCode.lrp_flag == 0) {
					catalog = "Standard";
				}
				if (this.selfPromoCode.lrp_flag == 2) {
					catalog = "LRP";
				}
			}
			// } else if (birthdayCode) {
			// 	catalog = "Standard";
			// }
			//var promote = this.selffirstOpentoAll;
			let minCart = {
				id: cv.id,
				is_result: type,
				is_confirm: is_confirm,
				promo_code: null,

				catalog: catalog,
				vip_no: for_vipno,
				first_order_status: first_order_status,

				customer_id: this.userInfo.value.binding.user_id,
				store_id: this.default_store_id,
				address_id: this.choosedAddress.id,
				total_num: cv.num,
				total_price: cv.total_price,
				total_pv: cv.total_pv,
				total_change_point: cv.total_change_point,
				total_change_point_num: cv.total_change_point_num,
				total_product_amount: cv.total_product_amount,
				delivery_fee: cv.delivery_fee,
				service_fee: cv.service_fee,
				ar_value: cv.ar_value,
				ab_value: cv.ab_value,
				pay_fee: cv.pay_fee,
				spec_code: this.promote_code||birthdayCode,
				lrpt_order: 0,
				remark: birthdayCode == "birthday" ? this.BHtext : null,
				proxy: this.selfLargePickupPerson,
				detail: ll,
			};
			let ret = await this.saveCartAction({ minCart, type: is_confirm });
			return ret;
		},
		async confirmLoad(type) {
			if (type == 0) {
				this.settlementLoad = true;
			} else if (type == 2) {
				if (!/^[A-Za-z]{0,6}$/.test(this.BHtext)) {
					//this.BHerror_text=true;
					this.BHerror_input = true;
					return false;
				}
				if (!this.BHtext) {
					//特殊處理
					this.BHerror_input = true;
					return false;
				}
				this.settlementLoad = true;
			} else {
				if (!this.getVipNo) {
					this.$router.push({
						path: "/order/product",
					});
					return;
				}
				this.continueLoad = true;
			}
			this.BHshow = false;

			var res = await this.confirm(type);
			if (res) {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: res,
				});
			}
			this.continueLoad = false;
			this.settlementLoad = false;
		},

		confirm1() {
			return new Promise((resolve, reject) => {
				this.$Modal.info({
					title: "升級提示",
					content:
						"您的本次訂購已經達到100PV，請完善您的個人資料成為優惠顧客，並且可以立即以優惠顧客價格支付本次訂單。<br>Your order has reached 100PV,please fill in your personal information to become preferred customer, and you can pay for this order at preferred customer price immediately.",
					okText: "是(Yes)",
					onOk: () => {
						location = `${cvoUrl}/vo/index.html#/enroll/appendPcInfo?token=${this.getAccessToken}&source=WebSite`;
					},
				});
			});
		},
		mergeConfirm() {
			if(this.mergeData.content){
				return new Promise((resolve, reject) => {
					this.$Modal.confirm({
						width: 750,
						title: "提示",
						content: this.mergeData.content,
						okText: "確定(Confirm)",
						cancelText: "取消(Cancel)",
						onOk: () => {
							resolve(true);
						},
						onCancel: async () => {
							resolve(false);
						},
					});
				});
			}else{
				return new Promise((resolve, reject) => {
					resolve(true);
				});
			}
		},
		selfPickupConfirm() {
			if(this.selfPickupData.content){
				return new Promise((resolve, reject) => {
					this.$Modal.confirm({
						width: 750,
						title: "提示",
						content: this.selfPickupData.content,
						okText: "確定(Confirm)",
						cancelText: "取消(Cancel)",
						onOk: () => {
							resolve(true);
						},
						onCancel: async () => {
							resolve(false);
						},
					});
				});
			}else{
				return new Promise((resolve, reject) => {
					resolve(true);
				});
			}
		},
		selfLargePickupConfirm() {
			if(this.selfLargePickupData.content){
				return new Promise((resolve, reject) => {
					this.$Modal.confirm({
						width: 750,
						title: "提示",
						content: this.selfLargePickupData.content,
						okText: "確定(Confirm)",
						cancelText: "取消(Cancel)",
						onOk: () => {
							resolve(true);
						},
						onCancel: async () => {
							resolve(false);
						},
					});
				});
			}else{
				return new Promise((resolve, reject) => {
					resolve(true);
				});
			}
		},
		async confirm(type) {
			let go = "/order/confirm";

			if (type == 0 || type == 2) {
				if (this.getVipNo) {
					go = "/order/confirm";
				} else {
					if(this.isMobile){
						this.showCustomer=true;
						//this.showCustomer=false;
						return 
					}

					this.goLogin();
					return;
				}
			} else {
				go = "/order/product?preaction=1";
			}
			this.SET_SELECTMERGE(0);
			let ret = null;
			if (type == 0) {
				ret = await this.checkOrder();
				if (ret) {
					return ret;
				}
				if (this.mergeShow && this.isMerge) {
					if (await this.mergeConfirm()) {
						var mergeType = this.optVirtualflag();
						this.SET_SELECTMERGE(mergeType);
					} else return;
				}else if (this.selfPickupShow && this.isSelfPickup) {
					if (await this.selfPickupConfirm()) {
						this.SET_SELECTMERGE(6);
					} else return;
				}else if (this.selfLargePickupShow && this.isSelfLargePickup) {
					if (await this.selfLargePickupConfirm()) {
						this.SET_SELECTMERGE(6);
					} else return;
				}
			}
			let pvResult = false;

			ret = await this.saveStoreIdAction(this.default_store);
			if (ret) {
				return ret;
			}
			ret = await this.saveThisCart(type == 1 ? 0 : 1, pvResult);
			if (ret && ret.response && ret.response.code == "1") {
				if (ret.data.value.code == 1) {
					this.SET_ORDERNN(null);
					// if (type == 0) {
					// 	if (
					// 		this.isOriginalPrice &&
					// 		(!this.selfCarNo ||
					// 			(this.payPv < 100 && this.selfCarNo))
					// 	) {
					// 		this.newValue = true;
					// 		return;
					// 	}
					// }

					this.$router.push({
						path: go,
					});
				} else if (ret.data.value.code == 1000) {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: ret.data.value.message,
						onOk: () => {
							this.SET_ORDERNN(null);
							this.$router.push({
								query: go,
							});
						},
					});
				} else if (ret.response.errorCode == "0100") {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: ret.data.value.message,
						loading: true,
						okText: "重新加載",
						onOk: async () => {
							await this.getWechatUserInfoAction();
							this.$Modal.remove();
						},
					});
				} else {
					return ret.data.value.message;
				}
			}
		},
		async confirmLoad1() {
			var data = this.selShopCart.filter((u) => u.product_flag == 10);
			if (data[0]) {
				this.settlementLoad = true;
				var ret = await this.checkOrder();
				this.settlementLoad = false;
				if (ret) {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: ret,
					});
					return false;
				}

				if(	this.nowDate <util.formatDate.dateFromStr(this.noBirthday)){
					this.BHshow = true;
				}
				else{
					this.BHtext='-1'
					await this.confirmLoad(0);
				}
				
			} else {
				await this.confirmLoad(0);
			}

			//this.$router.push("/order/payment");
		},
		async checkOrder() {
			if (
				!(
					this.userInfo &&
					this.userInfo.value &&
					this.userInfo.value.binding &&
					this.userInfo.value.binding.user_id
				)
			) {
				return "請登錄";
			} else if (!this.default_store_id) {
				return "請選擇一個配送倉庫";
			} else if (!this.qchoosedAddress.id) {
				return `請選擇址收貨地址<br>Please Select Delivery Address`;
			}

			var first_order_status = !this.forCustomer
				? this.userInfo.value.binding.first_order_status
				: this.forCustomer.first_order_status;
			var forlevel = !this.forCustomer
				? this.userInfo.value.binding.customer_type.toLowerCase()
				: this.forCustomer.customer_type;
			if (first_order_status == 0) {
				let defaultPV =
					this.userInfo.value.binding.default_pc_first_order_min_pv ||
					100;
				if (this.payPv < defaultPV && forlevel != "rt") {
					return "首購訂單點數不能小於100點";
				}
				// else if (
				// 	this.payPv < defaultPV &&
				// 	forlevel == "rt" &&
				// 	this.selfCarNo
				// ) {
				// 	return "首購訂單點數不能小於100點";
				// }
			}

			let ll = this.shopCartList();

			if (!ll || ll.length <= 0) {
				return "請選擇産品";
			}

			if (this.default_store_id != "501") {
				if (this.deliveryOnly(ll)) {
					return "部分産品僅限快遞";
				}
			}
			if (this.ListingOnly(ll)) {
				return "部分産品未上市";
			}

			var item = this.checkLRPTPV(ll);
			if (!this.isEmpty(item)) {
				return "您購買了" + item + "點數必須要滿足125點哦。";
			}

			var cv = this.cartInfo.value;
			if (true) {
				let arFee = parseFloat(this.arFee);
				arFee = isNaN(arFee) ? 0 : arFee;
				if (arFee > 0 && cv.total_change_point > 0) {
					return "親愛的顧客，非常抱歉，産品積分和點數兌換不能同時使用哦！";
				}

				var resultcashPay = ((this.cashPay / 3) * 2).toFixed(2);
				if (arFee > resultcashPay) {
					return "親愛的顧客，非常抱歉，使用産品積分不能超過支付金額兩倍！";
				}

				if (cv.total_change_point > cv.total_pv * 2) {
					return "親愛的顧客，非常抱歉，兌換回饋點數不能超過訂單總産品點數的兩倍";
				}
			}
			// var result = await this.CheckPoint({
			// 	point: cv.total_change_point,
			// 	step: 1
			// });
			// if (result) {
			// 	return result;
			// }
			// result = await this.CheckAR({ ar: this.arFee, step: 1 });
			// if (result) {
			// 	return result;
			// }

			var msg = await this.checkAccountBalanceAction({
				ar: this.arFee,
				pt: cv.total_change_point,
				ab: this.abFee,
				step: 1,
			});
			if (msg) {
				return msg;
			}

			if(this.isSelfLargePickup){
				if(!this.selfLargePickupPerson){
					return '請選擇團隊合併自提代表才能進行結帳'
				}
			}

			var store_id = this.default_store_id;
			var result = await this.CheckCart({ ll, store_id, step: 1 });
			if (result) {
				return result;
			}
			return null;
		},
		cdeleteAddress(address) {
			let vm = this;
			if (address.address_type == 0) {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: "註冊地址不可刪除哦",
				});
				return;
			}
			this.deleteAddress(address).then((res) => {
				if (vm.qchoosedAddress.id == address.id) {
					vm.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			});
		},
		chooseAddress: function (address) {
			this.CHOOSE_ADDRESS({ address, index: 0 });
		},
		noStock(product) {
			return (
				!(product.specproducts && product.specproducts.length > 0) ||
				!(product.control == 2 || product.control == 10)
			);
		},
		noStock1(product) {
			return !(product.control == 2 || product.control == 10);
		},
		noStockText(product) {
			if (product.is_inventory == 10 && this.default_store_id != "501") {
				return '僅快遞<em class="no_mobile">(Only Delivery)</em>';
			} else if (
				product.online_myo_begin &&
				product.online_myo_begin != "" &&
				this.nowDate <
					util.formatDate.dateFromStr(product.online_myo_begin)
			) {
				return '敬請期待<em class="no_mobile">(Coming Soon)</em>';
			} else if (this.noStock(product)) {
				if (product.product_flag == 1) {
					return '售罄<em class="no_mobile">(Sold Out)</em>';
				}
				return '暫售完<em class="no_mobile">(Out of Stock)</em>';
			}
			return null; //正常銷售
		},

		BHscancel() {
			this.BHshow = false;
		},
		showChoosePTList(products) {
			if (products) {
				this.choosedProducts = products;
			}
			this.showPTChange = !this.showPTChange;
		},
		resuldeliveryFee() {
			if(this.isMerge || this.isSelfPickup || this.isSelfLargePickup){
				this.fee = this.systemDetail.float_delivery_fee;
				return this.fee.toFixed(2);
			}else{
				if(this.choosedAddress && this.choosedAddress.id){
					if(this.choosedAddress.province_id == '110000'){
						this.fee = this.systemDetail.float_delivery_fee_hongkong;
						return this.fee.toFixed(2);
					}else if(this.choosedAddress.province_id == '120000'){
						this.fee = this.systemDetail.float_delivery_fee_macao;
						return this.fee.toFixed(2);
					}
				}else{
					var df = Number(this.systemDetail?.float_delivery_fee);
					return df - this.free <= 0
						? df.toFixed(2)
						: this.deliveryFee.toFixed(2);
				}
			}
		},
		operating() {
			this.isAllAddress = !this.isAllAddress;
		},
		showTips(msg, s, is) {
			this.$Toast.show(msg, { duration: s });
		},
		expiryMore() {
			location = `${cvoUrl}/vo/index.html#/lrp?token=${this.getAccessToken}&source=WebSite`;
		},
		goto() {
			location = `${cvoUrl}/vo/index.html#/enroll/create?level=rt`;
		},
		deleteProduct(product) {
			let sku = product.sku;
			let num = 0;
			let edit_cart = this.EDIT_CART1;
			edit_cart({ sku, num });
			//檢測大會代碼是否刪除 如果刪除 將刪除狀態
			var newcode = this.newpromoCode[sku];
			if (newcode) {
				this.REDUCE_NEWPROMOCODE(sku);
			}
			this.IsPromoteTip(sku, 0);
			this.updateCart(sku, num);
		},
		updateCart(sku, num) {
			var params = {
				//customerId:this.getUserId,
				sku,
				num,
			};
			this.updateCartAction(params);
		},
		close() {
			this.newValue = false;
		},
		goDetail(product) {
			this.$router.push("/order/product/detail?sku=" + product.sku);
		},
		allCarSel(){
			var cartCheck=this.cartCheck||{}
			var result=this.allSel
			this.SET_CARTCHECKALL(result)
			
			this.setOtherCar();
		},
		checkAutoAll(){
			if(this.isAllSelCart){
				this.allSel=true;
			}
			else{
				this.allSel=false;
			}
		},
		carSel(sku) {
			this.SET_CARTCHECK(sku);
			this.checkAutoAll();
			this.setOtherCar();
		},
		isCartCheck(sku) {
			// let checkList=this.cartCheck||[]
			// var item= checkList.filter(u=>u.sku==sku)
			// if(item[0]) return true
			// return false;
		},
		showPromoCode(products,type) {
			if (products) {
				this.PromoModel = products;
				this.PromoModelType=type
			}
			this.PromoModelShow = !this.PromoModelShow;
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.p-name1{
	//position: relative;
}
.load {
	width: 100%;
	//margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
	height: 350px;
	position: relative;
}
.cartPage {
	width: 78.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.warehouse {
	@include fontSize($font-size-15);
}
.selectWarehouse {
	border-radius: 0;
}
.toPc {
	margin-bottom: 40px;
	text-align: right;
	span {
		color: $theme-color;
	}
	.goto {
		text-decoration-line: underline;
		&:hover {
			text-decoration-line: underline;
		}
	}
}
.addressTitle {
	margin-top: 20px;
	margin-bottom: 10px;
	overflow: hidden;
	line-height: 30px;
	b {
		@include fontSize($font-size-16);
	}
	.addAddress {
		float: right;
		@include fontSize($font-size-14);
		border-radius: 0;
	}
}
.addressTag {
	@include fontSize($font-size-14);
}
.address {
	@include fontSize($font-size-15);
	overflow: hidden;
	.item {
		cursor: pointer;
		width: 100%;
		border: 1px solid #eee;
		padding: 20px;
		overflow: hidden;
		margin-bottom: 15px;
		&.select {
			border-color: $theme-color;
			border-width: 2px;
			&.hover {
				border-width: 2px;
			}
		}
		&.hover {
			border-color: $theme-color;
			border-width: 1px;
		}
		.left {
			float: left;
			i {
				display: inline-block;
				font-style: normal;
				@include fontSize($font-size-13);
				color: #fff;
				margin-right: 3px;
			}
		}
		.right {
			float: right;
			position: relative;
			top: 20px;
			img {
				width: 15px;
			}
		}
		.name {
		}
		.tel {
			margin-left: 20px;
			margin-right: 10px;
		}
		p {
			padding-top: 3px;
		}
	}
}
.showAllAddr {
	color: $theme-color;
	font-weight: 500;
	border-bottom: 1px solid #fff;
	display: block;
	cursor: pointer;
	@include fontSize($font-size-14);
	// margin-bottom: 20px;
}
.transition_dom {
	transition: all 0.3s linear 0s;
}
.productList {
}
.productList {
	text-align: center;
	margin: auto;
	margin-top: 20px;
	@include fontSize($font-size-14);
	.checkbox {
		width: 5%;
		white-space: nowrap;
	}
	.img {
		width: 120px;
		height: auto;
		padding: 10px;
		display: block; // height: 80px;
		min-height: 80px;
	}
	.p-img{
		width: 10%;
	}
	.p-left{
		float: left;
		margin-right: 10px;
	}
	.p-right{
		padding: 20px;
	}
	.p-name {
		text-align: left;
		position: relative;
		width: 40%;
		.p-name-span {
			width: 50%;
			position: relative;
			display: inline-block;
			.span_name {
				display: inline-block;
				@include fontSize($font-size-15);
			}
		}
		.exchange {
			margin-left: 30px;
			padding: 2px 4px;
			background-color: $theme-color;
			border-color: $theme-color;
			color: white;
			border-radius: 4px;
			cursor: pointer;
			&:hover {
				background-color: #c99ed3e8;
				border-color: #c99ed3e8;
			}
		}
	}
	.count,
	.sub-total,
	.sub-dh {
		width: 15%;
	}
	.price {
		width: 10%;
	}
	.sub-point{
		position: relative;
	}

	.delete {
		color: indigo;
		cursor: pointer;
		display: inline-block;
		margin-top: 5px;
	}
	.show_nostock {
		// font-weight: bold;
		@include fontSize($font-size-13);
		line-height: 24px;
		padding: 3px 5px;
		background-color: #ccc;
		color: white;
		border-radius: 5px;
		white-space: nowrap;
		em {
			font-style: normal;
		}
	}
	.product {
		.count{
			position: relative;
		}
		th {
			padding: 10px;
			font-weight: 500;
			@include fontSize($font-size-14);
		}
		td,
		th {
			border-bottom: 1px solid #eaeaea;
		}
		.other {
			padding-top: 3px;
			color: #999;
			span {
				margin-right: 10px;
			}
		}
	}
}
.promote {
	background: url(../../../assets/order/address_bottom.png) left top repeat-x;
	background-size: auto 4px;
	.promote-tag {
		color: rgb(255, 70, 29);
		display: inline-block;
		font-weight: 500;
		line-height: 8.2px;
		padding: 5px;
		margin-left: 5px;
		border: 1px solid rgb(255, 70, 29);
		border-radius: 7.03px;
		margin-right: 2.34px;
	}
}
.returninfo {
	padding-top: 2px;
	img {
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}
	span {
		vertical-align: text-bottom;
		color: #bc86c9;
	}
}
.hot {
	display: inline-block; // width: 36px;
	// height: 18px;
	line-height: 18px; //margin-left: 4px;
	@include fontSize($font-size-13);
	color: #fff;
	text-align: center;
	background-color: $theme-color;
	padding: 3px 10px;
	border-radius: 10px;
	//margin: 0px 5px;
	&:first-child {
		margin-left: 0;
	}
	b {
		font-weight: 500;
		@include fontSize($font-size-12);
	}
}
.select_pt_no {
	position: absolute;
	right: 0;
	top: 43%;
	span {
		cursor: pointer;
		@include fontSize($font-size-14);
		color: #fff;
		padding: 8px;
		background-color: #ccc;
		border-radius: 15px;
		border: 1px solid #ccc;
		div {
			display: inline;
		}
	}
}
.hotlist {
	margin-top: 5px;
	margin-bottom: 5px;
}
.gather {
	padding: 20px 0px;
	margin-bottom: 10px;
	margin-top: 10px;
	position: relative;
	min-height: 300px;
	.gather-left {
		width: 45vw;
		display: inline-block;
	}
	.element {
		position: relative;
		margin-bottom: 15px;
		@include fontSize($font-size-15);
		&.lrpt-text .value {
			// display: inline-block;
			// text-align: left;
			// width: 100%;
			width: inherit;
		}
		&.merge {
			margin: 20px 0;
			.name {
				color: $theme-color;
				text-align: left;
			
			}
			.tip-doubt {
				position: relative;
				top: -10px;
				margin: 0;
			}
			b {
				display: inline;
				@include fontSize($font-size-16);
			}
		}
	}
	.tip-doubt {
		width: $font-size-12;
		position: absolute;
		margin-left: 5px; // top: -3px;
		// left: 5px;
	}
	.total-pv,
	.total-fee,
	.ar {
		.name {
			cursor: pointer;
		}
	}
	.ar {
		//height: 45px;
		//margin-bottom: 15px;
	}
	.balance {
		//height: 45px;
		//margin-bottom: 20px;
	}
	.lapsePv .value {
	}
	.lapseMore {
		color: $theme-color;
	}
	.name {
		// width: 250px;
		display: inline-block;
		// text-align: right;
		b {
			display: block;
			text-align: left;
			font-weight: 500;
		}
	}
	.name1 {
		width: 250px;
		display: inline-block;
		text-align: right;
	}
	.value {
		width: 140px; //display: inline-block;
		text-align: right;
		font-weight: bold;
		float: right;
	}
	.add_x {
		text-decoration: line-through;
	}
	.move_x {
		text-decoration: none;
	}
	.mdeliveryFemv {
		display: flex;
		position: relative;
		top: -10px;	
		left: 0px;
		text-align: center;
		display: inline-block;
		div {
			font-size: 0.1rem;
			padding: 2px;
			border: 1px solid #666;
			border-radius: 10px; //margin-right: .1rem;
			transform: scale(1);
		}
		p {
			white-space: nowrap; //line-height: 20px;
		}
	}
	.gather-right {
		width: 20vw;
		min-width: 350px;
		margin-top: 20px;
		float: right;
		position: absolute;
		bottom: 50px;
		right: 0;
		button {
			// font-family: arial, "Microsoft YaHei";
			height: 56px;
			@include fontSize($font-size-16);
			font-weight: bold;
			b {
				@include fontSize($font-size-13);
				display: block;
			}
		}
		.cleanBtn,
		.gobuy {
			width: 45%;
			border-radius: 40px;
			margin-bottom: 10px;
		}
		.btnW {
			width: 10%;
			height: 56px;
			display: inline-block;
		}
		.confirm {
			border-radius: 40px;
		}
	}
	.total-amount {
		//margin-top: 10px;
		//height: 40px;
		.value {
			@include fontSize($font-size-20);
			color: #a27eaa;
		}
		&.amount1 {
			margin-top: 0px;
		}
	}
}
.main-bh {
	.tip {
		@include fontSize($font-size-13);
		margin-bottom: 10px;
		color: #31384a;
	}
	.highlight {
		animation: myfirst 2s;
		animation-iteration-count: infinite;
		-webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
		color: red;
	}

	@keyframes myfirst {
		0% {
			color: #ea1414;
		}
		25% {
			color: #31384a;
		}
		50% {
			color: #ea1414;
		}
		75% {
			color: #31384a;
		}
		100% {
			color: #ea1414;
		}
	}
}
@media (max-width: 768px) {
	.cleanBtn,
	.gobuy {
		width: 45%;
		border-radius: 40px;
		margin-bottom: 10px;
	}
}

//移動版樣式
@media (max-width: 768px) {
	.offset{
		// margin-bottom: 2rem;
	}
	.products_add{
		position: relative;
		
	}
	.cartPage {
		width: 95.03vw;
		margin: 15px auto;
	}
	.select_pt_no span div {
		display: none;
	}
	
	.no_mobile {
		display: none;
	}
	.warehouse {
		font-size: 0.65rem;
		line-height: 30px;
	}
	.selectWarehouse {
		font-size: 0.65rem;
		float: right;
	}
	.addressTitle {
		.addAddress {
			font-size: 0.65rem;
		}
		b {
			font-size: 0.65rem;
		}
	}
	.address {
		.item {
			.left {
				font-size: 0.65rem;
			}
		}
	}
	.gather {
		min-height: auto;
		margin-bottom: 0;
		.element {
			font-size: 16px;
		}
		.gather-left {
			width: 100%;
		}
		.gather-right {
			width: 90%;
			clear: both;
			position: initial;
			float: none;
			margin: auto;

		}
		.tip-doubt{
			width: 0.5rem;
		}
		.total-amount {
			.value {
				font-size: 0.65rem;
			}
		}
	}
	.checkbox {
		white-space: nowrap;
	}
	.productList {
		.product {
			th {
				font-size: 0.65rem;
			}
			td{
				padding: 10px 0px;
			}
		}
		.price {
			width: 15%;
			font-size: 0.65rem;
		}
		.img {
			width: 2rem;
			min-height: 2rem;
			padding: 0;
			display: initial;
			margin-right: 5px;
		}
		.p-name {
			padding-top: 5px;
			padding-bottom: 5px;
			.p-name-span {
				width: initial;
				> span {
					font-size: 0.65rem;
				}
				.span_name {
					font-size: 0.65rem;
				}
			}
		}
	}
	.promote {
		background-size: auto 2px;
	}
	.returninfo img {
		width: 15px;
		height: 15px;
	}
	.point_mobile {
		position: relative;
		.select_pt_no {
			position: initial;
			margin-top: 10px;
		}
		.select_pt_module {
			padding: 0;
			float: initial;
			margin-top: 10px;
		}
	}
	.gather-left .total-fee{
		margin-bottom: 25px;
	}
}
</style>